import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

import google from '../img/google-login.png';

const GoogleButton = styled.a`
  display: inline-block;
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
  font-weight: 900;
  padding: 5px;
  border-radius: 5px;
  border: 2px solid #3B3E4D;
  cursor: pointer;
  background: ${props => props.dark || props.darkOnMobile ? '#505663' : 'white'};
  color: ${props => props.dark || props.darkOnMobile ? 'white' : '#505663'};
  margin: ${props => props.noMargin ? '0' : '0 0 10px 0'};
  transition: .3s background, .3s color;
  &:before {
    content: '';
    display: inline-block;
    background: ${'url(' + google + ')'} center no-repeat;
    background-size: 100%;
    width: 30px;
    height: 30px;
    vertical-align: middle;
    margin: 0 5px 0 0;
  }
  span {
    display: inline-block;
    vertical-align: middle;
  }
  &:hover {
    background: ${props => props.dark || props.darkOnMobile ? 'white' : '#505663'};
    color: ${props => props.dark || props.darkOnMobile ? '#505663' : 'white'};
  }
  @media (min-width: ${breakpoints.tablet}) {
    font-size: 22px;
    padding: 15px;
    padding-right: 40px;
    background: ${props => props.dark ? '#505663' : 'white'};
    color: ${props => props.dark ? 'white' : '#505663'};
    &:hover {
      background: ${props => props.dark ? 'white' : '#505663'};
      color: ${props => props.dark ? '#505663' : 'white'};
    }
    &:before {
      margin: 0 15px 0 0;
    }
  }
`;

export default GoogleButton;



// WEBPACK FOOTER //
// ./src/styled-components/GoogleButton.js